// ERROR ACTION TYPES
export const GET_ERRORS = "GET_ERRORS";
export const CLEAR_ERRORS = "CLEAR_ERRORS";

//USER ACTION TYPES
export const USER_LOADING = "USER_LOADING";
export const USER_LOADED = "USER_LOADED";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const REGISTER_SUCCESS = "REGISTER_SUCCESS";
export const REGISTER_FAIL = "REGISTER_FAIL";

// MEAL ACTION TYPES
export const ADD_MEAL = "ADD_MEAL";
export const GET_MEALS = "GET_MEALS";
export const GET_MEAL_INFO = "GET_MEAL_INFO";
export const DELETE_MEAL = "DELETE_MEAL";
export const ADD_MEAL_FAIL = "ADD_MEAL_FAIL";
export const GET_MEALS_FAIL = "GET_MEALS_FAIL";
export const DELETE_MEAL_FAIL = "DELETE_MEAL_FAIL";
export const GET_MEAL_INFO_FAIL = "GET_MEAL_INFO_FAIL";
export const MEALS_LOADING = "MEALS_LOADING";

// ORDER ACTION TYPES
export const GET_ORDERS = "GET_ALL_ORDERS";
export const GET_ORDER_INFO = "GET_ORDER";
export const ADD_ORDER = "ADD_ORDER";
export const ADD_ORDER_FAIL = "ADD_ORDER_FAIL";
export const UPDATE_ORDER = "UPDATE_ORDER";
export const ADD_MEAL_TO_ORDER = "ADD_MEAL_TO_ORDER";
export const REMOVE_MEAL_FROM_ORDER = "REMOVE_MEAL_FROM_ORDER";
export const CANCEL_ORDER = "CANCEL_ORDER";
export const ORDER_LOADING = "ORDER_LOADING";
export const DELETE_ORDER = "DELETE_ORDER";
export const CLEAR_CART = "CLEAR_CART";
export const SET_DELIVERY_TIME = "SET_DELIVERY_TIME";
export const SET_DELIVERY_TYPE = "SET_DELIVERY_TYPE";

// PAYMENT ACTION TYPES
export const CREATE_PAYMENT_INTENT_SUCCESS = "CREATE_PAYMENT_INTENT_SUCCESS";
export const CREATE_PAYMENT_INTENT_FAIL = "CREATE_PAYMENT_INTENT_FAIL";
export const CONFIRM_CARD_PAYMENT_SUCCESS = "CONFIRM_CARD_PAYMENT_SUCCESS";
export const CONFIRM_CARD_PAYMENT_FAIL = "CONFIRM_CARD_PAYMENT_FAIL";
export const PAYMENT_PROCESSING = "PAYMENT_PROCESSING";
export const LOAD_CHECKOUT = "LOAD_CHECKOUT";
export const FINISH_CHECKOUT = "FINISH_CHECKOUT";
